import roleManagementService from '../services/roleManagement.service';
import userManagementService from '../services/userManagement.service';
import AuthService from '../services/auth.service';
import SettingsService from '../services/generalSettings.service'

export const security = {
  state: {
    permissions: [],
    users: [],
    roles: [],
    settings: [],
    invalidPasswords: [],
  },

//********************************************************************GETTERS*****************************************************************************************
//********************************************************************************************************************************************************************

  getters: {
    allPermissions: (state) => state.permissions,
    allUsers: (state) => state.users,
    unconfirmedUsers: (state) => {return [state.users.filter(a => a.CheckerID == 0),[state.users.title = "Users"]]},
    allRoles: (state) => state.roles,
    unconfirmedRoles: (state) => {return [state.roles.filter(a => a.CheckerID == 0),[state.roles.title = "Roles"]]},
    Settings: (state) => state.settings,
    allInvalidPasswords: (state) => state.invalidPasswords,
  },

//********************************************************************ACTIONS*****************************************************************************************
//********************************************************************************************************************************************************************

  actions: {

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ROLES

  createRole({ commit }, data) {
      return roleManagementService.create(data).then(
        response => {
          commit('newRole', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllRoles({ commit }) {
      return roleManagementService.getAllRoles().then(
        response => {
          commit('setRoles', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllPermissions({ commit }) {
      return roleManagementService.getAllPermissions().then(
        response => {
          commit('setPermissions', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateRole({ commit }, data) {
      return roleManagementService.updateRoles(data.SecurityRoleID, data).then(
        response => {
          commit('updRole', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteRole({ commit }, data) {
      return roleManagementService.deleteRoles(data.SecurityRoleID).then(
        response => {
          commit('dltRole', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateRolePermissions({ commit }, data) {
      return roleManagementService.updateRolePermissions(data.SecurityRoleID, data).then(
        response => {
          commit('updRolePermissions', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USERS

  createUser({ commit }, data) {
      return AuthService.register(data).then(
        response => {
          commit('newUser', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllUsers({ commit }) {
      return userManagementService.getAllUsers().then(
        response => {
          commit('setUsers', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateUser({ commit }, data) {
      return userManagementService.updateUser(data.SecurityUserID, data).then(
        response => {
          commit('updUser', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteUser({ commit }, data) {
      return userManagementService.deleteUser(data.SecurityUserID).then(
        response => {
          commit('dltUser', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    addUser_Role({ commit }, data) {
      return userManagementService.addUser_Role(data.SecurityUserID, data).then(
        response => {
          commit('updUserRole', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    removeUser_Role({ commit }, data) {
      return userManagementService.removeUser_Role(data.SecurityUserID, data).then(
        response => {
          commit('updUserRole', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    // changePassword({ commit }, data) {
    //   return userManagementService.changePassword(data.SecurityUserID, data).then(
    //     response => {
    //       commit('updUser', data);
    //       return Promise.resolve(response);
    //     },
    //     error => {
    //       return Promise.reject(error);
    //     }
    //   );
    // },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// GENERAL SETTINGS

  createInvalidPassword({ commit }, data) {
      return SettingsService.create(data).then(
        response => {
          commit('newPassword', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllInvalidPasswords({ commit }) {
      return SettingsService.getAllInvalidPasswords().then(
        response => {
          commit('setPasswords', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getSettings({ commit }) {
      return SettingsService.getSettings().then(
        response => {
          commit('setSettings', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateInvalidPasswords({ commit }, data) {
      return SettingsService.updateInvalidPasswords(data.id, data).then(
        response => {
          commit('updPassword', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteInvalidPasswords({ commit }, data) {
      return SettingsService.deleteInvalidPasswords(data.id).then(
        response => {
          commit('dltPassword', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateSettings({ commit }, data) {
      return SettingsService.updateSettings(data.id, data).then(
        response => {
          commit('updSettings', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  },

//********************************************************************MUTATIONS***************************************************************************************
//********************************************************************************************************************************************************************
  mutations: {

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ROLES

    setRoles: (state, roles) => (state.roles = roles),
    setPermissions: (state, permissions) => (state.permissions = permissions),
    newRole: (state, newRole) => state.roles.unshift(newRole.role),
    updRole: (state, updatedRole) => {
      const index = state.roles.findIndex(roles => roles.SecurityRoleID === updatedRole.SecurityRoleID);
      if (index !== -1) {
        state.roles.splice(index, 1, updatedRole);
      }
    },
    dltRole: (state, Role) => {
      const index = state.roles.findIndex(roles => roles.SecurityRoleID === Role.SecurityRoleID);
      if (index !== -1) {
        state.roles.splice(index, 1);
      }
    },
    updRolePermissions: (state, updatedRolePermission) => {
      const index = state.roles.findIndex(roles => roles.SecurityRoleID === updatedRolePermission.SecurityRoleID);
      if (index !== -1) {
        state.roles.splice(index, 1, updatedRolePermission);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USERS

    newUser: (state, user) => state.users.unshift(user.newUser),
    setUsers: (state, users) => (state.users = users),
    updUser: (state, updatedUser) => {
      const index = state.users.findIndex(users => users.SecurityUserID === updatedUser.SecurityUserID);
      if (index !== -1) {
        state.users.splice(index, 1, updatedUser);
      }
    },
    dltUser: (state, User) => {
      const index = state.users.findIndex(users => users.SecurityUserID === User.SecurityUserID);
      if (index !== -1) {
        state.users.splice(index, 1);
      }
    },
    updUserRole: (state, updatedUser) => {
      const index = state.users.findIndex(users => users.SecurityUserID === updatedUser.user.SecurityUserID);
      if (index !== -1) {
        state.users.splice(index, 1, updatedUser.user);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// GENERAL SETTINGS

    newPassword: (state, newPassword) => state.invalidPasswords.unshift(newPassword.password),
    setPasswords: (state, Passwords) => (state.invalidPasswords = Passwords),
    setSettings: (state, settings) => (state.settings = settings),
    updPassword: (state, updatedPassword) => {
      const index = state.invalidPasswords.findIndex(invalidPasswords => invalidPasswords.id === updatedPassword.id);
      if (index !== -1) {
        state.invalidPasswords.splice(index, 1, updatedPassword);
      }
    },
    dltPassword: (state, Password) => {
      const index = state.invalidPasswords.findIndex(invalidPasswords => invalidPasswords.id === Password.id);
      if (index !== -1) {
        state.invalidPasswords.splice(index, 1);
      }
    },
    updSettings: (state, updatedSettings) => {
      const index = state.settings.findIndex(settings => settings.id === updatedSettings.id);
      if (index !== -1) {
        state.settings.splice(index, 1, updatedSettings);
      }
    },
  },
}
